// photoswipe
// PhotoSwipeLightboxインスタンスをグローバル変数に保存し、テンプレートからアクセスできるようにする
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
window.currentPhotoSwipelightbox = null;
window.initPhotoSwipe = (gallery, children) => {
  // 既存のインスタンスがあれば破棄
  if (window.currentPhotoSwipelightbox) {
    window.currentPhotoSwipelightbox.destroy();
  }
  const closeSVGString = `
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M26 1.82875L24.1713 0L13 11.1713L1.82875 0L0 1.82875L11.1713 13L0 24.1713L1.82875 26L13 14.8287L24.1713 26L26 24.1713L14.8287 13L26 1.82875Z" fill="white"/>
  </svg>
  `;
  const zoomSVGString = `
  <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12.5424C2 6.72576 6.74589 2 12.6131 2C18.4804 2 23.2263 6.72576 23.2263 12.5424C23.2263 18.3591 18.4804 23.0849 12.6131 23.0849C6.74589 23.0849 2 18.3591 2 12.5424ZM12.6131 0C5.65285 0 0 5.6097 0 12.5424C0 19.4752 5.65285 25.0849 12.6131 25.0849C15.3251 25.0849 17.8386 24.2332 19.8966 22.7835L26.6551 29.5009C27.4385 30.2795 28.7048 30.2757 29.4835 29.4922C30.2621 28.7088 30.2583 27.4425 29.4748 26.6638L22.7618 19.9917C24.3103 17.9094 25.2263 15.3331 25.2263 12.5424C25.2263 5.6097 19.5734 0 12.6131 0Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.45508 12.542C6.45508 11.7136 7.12665 11.042 7.95508 11.042H17.2699C18.0983 11.042 18.7699 11.7136 18.7699 12.542C18.7699 13.3704 18.0983 14.042 17.2699 14.042H7.95508C7.12665 14.042 6.45508 13.3704 6.45508 12.542Z" fill="white"/>
    <path class="hidden-path" fill-rule="evenodd" clip-rule="evenodd" d="M12.6133 6.41309C13.4417 6.41309 14.1133 7.08466 14.1133 7.91309V17.1712C14.1133 17.9996 13.4417 18.6712 12.6133 18.6712C11.7849 18.6712 11.1133 17.9996 11.1133 17.1712V7.91309C11.1133 7.08466 11.7849 6.41309 12.6133 6.41309Z" fill="white"/>
  </svg>
  `;
  const options = {
    gallery: gallery,
    children: children,
    arrowPrev: false,
    arrowNext: false,
    closeSVG: closeSVGString,
    zoomSVG: zoomSVGString,
    mouseMovePan: true,
    initialZoomLevel: 'fit',
    pswpModule: () => import('photoswipe')
  };
  window.currentPhotoSwipelightbox = new PhotoSwipeLightbox(options);
  window.currentPhotoSwipelightbox.on('uiRegister', () => {
    window.currentPhotoSwipelightbox.pswp.ui.registerElement({
      name: 'caption',
      appendTo: 'root',
      onInit: (el) => {
        window.currentPhotoSwipelightbox.pswp.on('change', () => {
          const currSlideElement = window.currentPhotoSwipelightbox.pswp.currSlide.data.element;
          let captionHTML = '';
          if (currSlideElement) {
            const hiddenCaption = currSlideElement.querySelector('#js-custom__picture-caption');
            if (hiddenCaption) {
              captionHTML = hiddenCaption.innerHTML;
            }
          }
          el.innerHTML = captionHTML || '';
        });
      }
    });
  });
  window.currentPhotoSwipelightbox.init();
}



// Aboutページ　Slick初期化
function initAboutSlick() {
  $("#js-about__slide-content").slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7500,
    cssEase: "linear",
    lazyLoad: 'ondemand',
    accessibility: false,
    draggable: false,
    swipe: false,
    arrows: false,
    variableWidth: true
  });
}

// フェードイン処理
function fadeInContents() {
  const contents = document.querySelectorAll('.js-fade-in');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  });
  contents.forEach(content => {
    observer.observe(content);
  });
};

// MV　Slick初期化
function initTopSlick() {
  $("#js-mv-slide").slick({
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dots: true,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
  });
}

// TOPページ ひな人形　五月人形スライダー初期化
function initTopDollsSlick() {
  const slides = document.querySelectorAll('.js-top__dolls-slide');
  slides.forEach(slide => {
    $(slide).slick({
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      lazyLoad: 'ondemand',
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false
    });
  });
}

// アコーディオン
class Accordion {
  constructor(accordionElement) {
    this.accordionElement = accordionElement;
    this.buttonElement = accordionElement.querySelector(".js-accordion__trigger");
    this.contentElement = accordionElement.querySelector(".js-accordion__content");
    this.isOpen = false;
    this.buttonElement.addEventListener("click", () => {
      this.toggleAccordion();
    });
  }
  toggleAccordion() {
    this.isOpen = !this.isOpen;
    this.accordionElement.classList.toggle("is-active", this.isOpen);
    if (this.isOpen) {
      this.contentElement.style.maxHeight = this.contentElement.scrollHeight + "px";
    } else {
      this.contentElement.style.maxHeight = null;
    }
  }
}
function initAccordions() {
  const accordions = document.querySelectorAll(".js-accordion");
  accordions.forEach(accordionElement => {
    new Accordion(accordionElement);
  });
}

// スクロール時にヘッダーを隠す
function adjustHeaderOnScroll() {
  const header = document.getElementById('js-header__content');
  if (!header) return;

  let lastScrollTop = window.scrollY;
  let ticking = false;

  const updateHeaderScroll = () => {
    let currentScrollTop = window.scrollY;

    // Safariの慣性スクロールでの負の値を防ぐ
    if (currentScrollTop < 0) {
      currentScrollTop = 0;
    }

    if (currentScrollTop > lastScrollTop) {
      header.classList.add('is-hide');
    } else if (currentScrollTop < lastScrollTop) {
      header.classList.remove('is-hide');
    }

    lastScrollTop = currentScrollTop;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderScroll);
      ticking = true;
    }
  });

  // 初期状態でのスクロール位置のチェック
  if (window.scrollY > 0) {
    header.classList.add('is-hide');
  }
}

// ヘッダーのコンテンツをドロワーにコピー
function copyContentToDrawer() {
  const headerUtility = document.getElementById('js-header__utility');
  if (!headerUtility) return;
  const headerUtilityContent = headerUtility.innerHTML;
  const drawerUtilityElement = document.getElementById('js-drawer__utility');
  drawerUtilityElement.innerHTML = headerUtilityContent;
}

// 組み合わせ商品の表示切り替え
const toggleCombiItems = () => {
  const showMoreButton = document.querySelector('#js-combi__action-button');
  const textElem = showMoreButton.querySelector('#js-combi__button-text');
  const combiList = document.querySelector('#js-combi__list');
  const hiddenItems = document.querySelectorAll('.js-combi__list-item:nth-child(n+9)');
  if (textElem.textContent === "もっと見る") {
    showMoreButton.classList.add('is-arrow-up');
    textElem.textContent = "短く見る";
    combiList.classList.add('is-all-show');
    hiddenItems.forEach(item => item.classList.remove('is-hide'));
  } else {
    showMoreButton.classList.remove('is-arrow-up');
    textElem.textContent = "もっと見る";
    combiList.classList.remove('is-all-show');
    hiddenItems.forEach(item => item.classList.add('is-hide'));
  }
}
const updateCombiItemView = () => {
  const hiddenItems = document.querySelectorAll('.js-combi__list-item:nth-child(n+9)');
  if (window.innerWidth <= 767) {
    hiddenItems.forEach(item => item.classList.add('is-hide'));
  } else {
    hiddenItems.forEach(item => item.classList.remove('is-hide'));
  }
}
function initCombiItems() {
  updateCombiItemView();
  const showMoreButton = document.querySelector('#js-combi__action-button');
  if (showMoreButton) {
    showMoreButton.addEventListener('click', toggleCombiItems);
  }
}

// 商品一覧のフィルタリング
function handleProductListFiltering() {
  const buttons = document.querySelectorAll('.js-product__list-type-button');
  buttons.forEach(button => {
    button.addEventListener('click', (e) => {
      buttons.forEach(btn => {
        btn.classList.remove('is-active');
      });
      e.currentTarget.classList.add('is-active');
      const dataShowType = e.currentTarget.getAttribute('data-show-type');
      const listItems = document.querySelectorAll('.js-product__list-item');
      listItems.forEach(item => {
        if (item.classList.contains(dataShowType)) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });

  // '.is-init-select' クラスを持つ要素を自動的にクリックする
  const initialSelectedButton = document.querySelector('.js-product__list-type-button.is-init-select');
  if (initialSelectedButton) {
    initialSelectedButton.click();
  }
}

// 商品詳細ページのフロートカート
function initFloatCart() {
  const productDetail = document.querySelector('#js-product__detail');
  const floatCart = document.querySelector('#js-product__detail-float-cart');

  if (!productDetail || !floatCart) return;

  let ticking = false;

  function updateFloatCartPosition() {
    const productDetailRect = productDetail.getBoundingClientRect();
    if (window.innerWidth >= 768) {
      const productDetailTop = window.scrollY + productDetailRect.top;
      const productDetailBottom = window.scrollY + productDetailRect.bottom;
      const floatCartHeight = floatCart.offsetHeight;
      if (window.scrollY >= productDetailTop) {
        const maxScroll = productDetailBottom - floatCartHeight;
        if (window.scrollY < maxScroll) {
          const translateY = window.scrollY - productDetailTop;
          floatCart.style.transform = 'translateY(' + translateY + 'px)';
        } else {
          floatCart.style.transform = 'translateY(' + (productDetailBottom - productDetailTop - floatCartHeight) + 'px)';
        }
      } else {
        floatCart.style.transform = 'none';
      }
    } else {
      const actionElement = document.querySelector('#js-detail-product__action');
      if (actionElement) {
        const actionRect = actionElement.getBoundingClientRect();
        const floatCartStyle = getComputedStyle(floatCart);
        const floatCartBottom = floatCartStyle.getPropertyValue('bottom');
        const floatCartBottomValue = parseInt(floatCartBottom, 10);
        if (actionRect.bottom < 0 && (productDetailRect.bottom + floatCartBottomValue) > window.innerHeight) {
          floatCart.style.transform = 'translateX(0)';
        } else {
          floatCart.style.transform = 'translateX(100%)';
        }
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateFloatCartPosition);
      ticking = true;
    }
  });

  // 初期状態でのスクロール位置のチェック
  if (window.innerWidth >= 768) {
    if (window.scrollY > 0) {
      updateFloatCartPosition();
    }
  } else {
    updateFloatCartPosition();
  }
}

// カスタムページの横スクロール
function initDraggableScroll() {
  const scrollContainer = document.getElementById('js-custom__visual-scroll');

  if (!scrollContainer) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  scrollContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    scrollContainer.classList.add('active');
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
  });

  scrollContainer.addEventListener('mouseleave', () => {
    isDown = false;
    scrollContainer.classList.remove('is-active');
  });

  scrollContainer.addEventListener('mouseup', () => {
    isDown = false;
    scrollContainer.classList.remove('is-active');
  });

  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 1;
    scrollContainer.scrollLeft = scrollLeft - walk;
  });
}

// メーラー立ち上げ
function setupMailSender() {
  const mailElements = [{
    id: 'js-custom__send-mail',
    textAttr: 'data-product-name',
    urlAttr: 'data-product-url',
    subject: 'ページのURLを共有します',
    formatBody: (text, url) => `${text} ${url}`
  }, {
    id: 'js-refer__send-mail',
    textAttr: 'data-refer-code',
    urlAttr: 'data-refer-url',
    subject: '紹介コードとURLを共有します',
    formatBody: (text, url) => `紹介コード：${text}\n紹介URL：${url}`
  }];

  mailElements.forEach((mailElementInfo) => {
    const mailElement = document.getElementById(mailElementInfo.id);
    if (mailElement) {
      mailElement.addEventListener('click', () => {
        const mailText = mailElement.getAttribute(mailElementInfo.textAttr);
        const mailUrl = mailElement.getAttribute(mailElementInfo.urlAttr);
        const subject = encodeURIComponent(mailElementInfo.subject);
        const body = encodeURIComponent(mailElementInfo.formatBody(mailText, mailUrl));
        const mailtoLink = `mailto:?subject=${subject}&body=${body}`;

        window.location.href = mailtoLink;
      });
    }
  });
}


// シェアメニュー
function initShareMenu() {
  const shareButtons = ['js-custom__share', 'js-refer__share'];
  const shareMenus = ['js-custom__share-menu', 'js-refer__share-menu'];

  shareButtons.forEach((buttonId, index) => {
    const shareButton = document.getElementById(buttonId);
    if (shareButton) {
      shareButton.addEventListener('click', (event) => {
        const menu = document.getElementById(shareMenus[index]);
        menu.classList.toggle('is-active');
        event.stopPropagation();
      });
    }
  });

  document.addEventListener('click', (event) => {
    shareMenus.forEach((menuId) => {
      const menu = document.getElementById(menuId);
      if (menu && !menu.contains(event.target) && menu.classList.contains('is-active')) {
        menu.classList.remove('is-active');
      }
    });
  });
}

// 紹介ページのフロートカート
function initFloatButton() {
  const referRange = document.querySelector('#js-refer__range');
  const floatButton = document.querySelector('#js-refer__float');

  if (!referRange || !floatButton) return;

  let ticking = false;

  function updateFloatButtonPosition() {
    const referRangeRect = referRange.getBoundingClientRect();
    if (window.innerWidth >= 768) {
      const referRangeTop = window.scrollY + referRangeRect.top;
      const referRangeBottom = window.scrollY + referRangeRect.bottom;
      const floatButtonHeight = floatButton.offsetHeight;
      if (window.scrollY >= referRangeTop) {
        const maxScroll = referRangeBottom - floatButtonHeight;
        if (window.scrollY < maxScroll) {
          const translateY = window.scrollY - referRangeTop;
          floatButton.style.transform = 'translateY(' + translateY + 'px)';
        } else {
          floatButton.style.transform = 'translateY(' + (referRangeBottom - referRangeTop - floatButtonHeight) + 'px)';
        }
      } else {
        floatButton.style.transform = 'none';
      }
    } else {
      const codeArea = document.querySelector('.js-refer__code');
      if (codeArea) {
        const codeAreaRect = codeArea.getBoundingClientRect();
        const isInViewport = (codeAreaRect.top < window.innerHeight && codeAreaRect.bottom >= 0);

        if (isInViewport) {
          floatButton.style.transform = 'translateX(100%)';
        } else {
          floatButton.style.transform = 'translateX(0)';
        }
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateFloatButtonPosition);
      ticking = true;
    }
  });

  // 初期状態でのスクロール位置のチェック
  if (window.innerWidth >= 768) {
    if (window.scrollY > 0) {
      updateFloatButtonPosition();
    }
  } else {
    updateFloatButtonPosition();
  }
}

// 紹介ページのクリップボードコピー
function setupCopyToClipboard() {
  const copyElement = document.getElementById('js-refer__copy');
  if (copyElement) {
    copyElement.addEventListener('click', () => {
      const referCode = copyElement.getAttribute('data-refer-code');
      const referUrl = copyElement.getAttribute('data-refer-url');
      const textToCopy = `紹介コード：${referCode}\n紹介URL：${referUrl}`;

      navigator.clipboard.writeText(textToCopy).then(() => {
        alert('コピーしました。');
      }).catch(err => {
        console.error('コピーに失敗しました:', err);
      });
    });
  }
}

// お客様の声投稿ページの開閉
const toggleActiveState = (icon, selector) => {
  if (icon.classList.contains('is-active')) {
      icon.classList.remove('is-active');
      document.querySelectorAll(selector).forEach(elem => elem.classList.remove('is-active'));
  } else {
      icon.classList.add('is-active');
      document.querySelectorAll(selector).forEach(elem => elem.classList.add('is-active'));
  }
}
const setupToggle = (iconSelector, elementSelector) => {
  const icons = document.querySelectorAll(iconSelector);
  icons.forEach(icon => {
      icon.addEventListener('click', () => {
          toggleActiveState(icon, elementSelector);
      });
  });
}
function voicePostFormToggle() {
  setupToggle('.js-post-form-view-icon--name', '.js-post-form-view-elem--name');
  setupToggle('.js-post-form-view-icon--birthday', '.js-post-form-view-elem--birthday');
}

// お客様の声 ページャーのリンクに#p-voice__typeを追加
function updateVoicePagerLinks() {
  const pagerLinks = document.querySelectorAll("#js-voice-pager a");  
  pagerLinks.forEach(link => {
      link.href += "#p-voice__type";
  });
}


/* ---------------------------------------------------------------------
DOMContentLoaded
--------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  initAboutSlick();
  fadeInContents();
  initTopSlick();
  initTopDollsSlick();
  initAccordions();
  adjustHeaderOnScroll();
  copyContentToDrawer();
  initCombiItems();
  handleProductListFiltering();
  initFloatCart();
  initDraggableScroll();
  setupMailSender();
  initShareMenu();
  initFloatButton();
  setupCopyToClipboard();
  voicePostFormToggle();
  updateVoicePagerLinks();
});

/* ---------------------------------------------------------------------
resize
--------------------------------------------------------------------- */
let currentWidth = window.innerWidth;
let resizeTimer = null;

window.addEventListener('resize', () => {
  if (currentWidth === window.innerWidth) return;
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    updateCombiItemView();
    currentWidth = window.innerWidth;
  }, 200);
});

/* ---------------------------------------------------------------------
cartUpdated
const event = new Event('cartUpdated');
document.dispatchEvent(event);
--------------------------------------------------------------------- */
// document.addEventListener('cartUpdated', () => {
//   copyContentToDrawer();
// });